import { render } from "./QA.vue?vue&type=template&id=d485f684"
import script from "./QA.vue?vue&type=script&lang=js"
export * from "./QA.vue?vue&type=script&lang=js"
script.render = render

export default script